import React from 'react';
import Price from '../../shared/price';
import {FaMinus, FaPlus} from 'react-icons/fa';
import {connect} from "react-redux";
import './Total.css';

class Total extends React.Component {
    formatDiscount(sum) {
        if (this.props.coupon) {
            const discountType = this.props.coupon.type;
            const discount = this.props.coupon.priceReduction;
            let obj = {};

            if (discountType === 'FLAT_RATE') {
                obj[discountType] = discount;
                obj[discount] = sum - discount < 0 ? 0 : sum - discount;
                return obj;
            }

            if (discountType === 'PERCENTAGE') {
                obj[discountType] = sum * (discount / 100);
                obj[discount] = sum - (sum * (discount / 100)) < 0 ? 0 : sum - (sum * (discount / 100));
                return obj;
            }
        }
    }

    render() {
        let listItem;
        if (this.props.nameCostPairs) {
            listItem = (
                this.props.nameCostPairs.map((nameCost, index) =>
                    <li key={index} className="num">
                        <div className="lineItemRow">
                            <div className="nameCol">{nameCost.name}</div>
                            <div className="priceCol">
                                {this.props.costs.length > 1 && index === this.props.costs.length - 1 ?
                                    <FaPlus size='.75em'/> : null}
                                <Price price={nameCost.cost}/>
                            </div>

                        </div>
                    </li>
                )
            )

        } else {
            listItem = (
                this.props.costs.map((num, index) =>
                    <li key={index} className="num">
                        <div className="lineItemRow">
                            <div className="priceCol">
                                {this.props.costs.length > 1 && index === this.props.costs.length - 1 ?
                                    <FaPlus size='.75em'/> : null}
                                <Price price={num}/>
                            </div>

                        </div>
                    </li>
                )
            );
        }

        let sum = this.props.costs.reduce((a, b) => a + b, 0);

        if (this.props.costs) {
            return (
                <div className="total">
                    {
                        this.props.coupon || this.props.costs.length > 1 ?
                            <ul>
                                {listItem}
                                {
                                    this.props.coupon ?
                                        <div className="lineItemRow">
                                            <div
                                                className="nameColCoupon">{this.props.coupon.code}</div>
                                            <div className="priceColCoupon">
                                                <FaMinus size='.75em'/>
                                                <Price price={this.formatDiscount(sum)[this.props.coupon.type]}/>
                                            </div>

                                        </div>
                                        :
                                        null
                                }
                                <div className="underline"></div>
                                Subtotal ({this.props.costs.length} {this.props.costs.length > 1 ? 'items' : 'item'}) :
                                <span className="sum">
                                <Price
                                    price={this.props.coupon ? this.formatDiscount(sum)[this.props.coupon.priceReduction] : sum}/>
                            </span>
                            </ul> :
                            null
                    }
                </div>
            );
        } else {
            return null;
        }
    };
}

const mapStateToProps = state => ({
    coupon: state.couponReducer.coupon
});

export default connect(mapStateToProps)(Total);
